import { api } from './configs/axiosConfig';

const endPoint = "/location";

export const locationAPI = {
    getLocations: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    }
}